<template>
  <div class="display-ticket-surplus" v-if="reserve.length">
    <van-button color="#aab" size="mini" @click="handleShowChange">X</van-button>
    <div style="height:270px;overflow-y: scroll">
      <div v-for="(item, index) in reserve" :key="index" class="reserve">
        <p class="date">
          {{ item.date }}{{ item.count === -1 ? '' : '(' + item.count + '人)' }}&nbsp;
          {{ item.valid ? '' : item.tab }}
        </p>
        <van-row>
          <van-col
            span="12"
            v-for="(reserve, index) in item.reserve"
            :key="index"
            style="margin: 1% 0;fontSize:70%;"
          >
            {{ reserve.start_time }}-{{ reserve.end_time }}
            {{ item.count === -1 ? '' : '(' + reserve.count + '人)' }} &nbsp;
            {{ item.valid ? '' : item.tab }}
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    reserve: [Array],
  },
  methods: {
    handleShowChange() {
      this.$emit('showChange');
    },
  },
};
</script>
<style lang="less" scoped>
.display-ticket-surplus {
  background: #ddd;
  border-radius: 5px;
  padding: 3% 0 3% 3%;
  overflow: hidden;
  color: grey;
  font-size: 90%;
  .van-button {
    position: absolute;
    top: 3%;
    right: 3%;
    width: 18px;
    height: 18px;
  }
  .date {
    margin: 1% 0;
  }
}
</style>
